import { useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';

import youtubeJSON from '../utils/youtube.json';
import useContent from '@/localization/data_export';

export default function YoutubeSlide() {
  const anchorTitle = useContent(['global', 'anchor', 'title']);

  const observerRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let observe = null;

    if (!isVisible && observerRef.current) {
      observe = new IntersectionObserver(([entry], observer) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      });

      observe.observe(observerRef.current);
    }
    return () => {
      if (observe) observe.disconnect();
    };
  }, []);

  return (
    <div ref={observerRef}>
      <h2 className="slide-title">
        <strong>Arirang Channel</strong> on YouTube
      </h2>
      <div className="slide-wrapper">
        {isVisible && (
          <Swiper spaceBetween={16} slidesPerView={8} navigation={youtubeJSON.data.length > 8}>
            {youtubeJSON.data.map((item) => (
              <SwiperSlide key={item.key}>
                <a href={item.url} target="_blank" rel="noreferrer" title={anchorTitle}>
                  <img
                    src={item.image}
                    alt=""
                    onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
                  />
                  <p>{item.title}</p>
                </a>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </div>
  );
}
